/* eslint-disable */

import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');

export default {
  name: 'unit-info-edit',
  components: {
  },
  props: [],
  data() {
    return {
      quizData: {
        name: '',
      },
      submitted:false,
    }
  },
  computed: {
  },
  mounted() {
    this.getIvQuizUniInfoByIdMethod();
  },
  methods: {
    getIvQuizUniInfoByIdMethod() {
      this.$store.dispatch('getIvQuizUniInfoByIdAction', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.quizData.name = response.data.data.name
      })
    },
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            name: this.quizData.name
          }
          this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: this.$route.params.quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                toast.success(res.data.msg);
                this.$router.push('/interview/quiz/unit/list/')
                this.submitted = false;
              }
            })
            .catch((err) => {
              this.submitted = false;
            })
          return
        }
      });
    },
  },
}
